import { DataCard } from "components/common/DataCard";
import { DetailsColumn } from "components/common/DetailsColumn";
import { formatSortCode, LoanDetails } from "domain/yourBBLS";
import { toDateFormat } from "util/date";
import { money } from "util/money";

type LoanSummaryProps = {
  loanDetails: LoanDetails;
  className?: string;
};

export const LoanSummary = ({ loanDetails, className }: LoanSummaryProps) => {
  return (
    <>
      <DataCard className={className}>
        <div className="loan-items">
          <div className="loan-title">Loan Details</div>
          <DetailsColumn
            label="Interest rate"
            value={`${loanDetails.interestRate}%`}
          />
          <DetailsColumn
            label="Monthly repayment"
            value={money(loanDetails.monthlyRepaymentAmount)}
          />
          <DetailsColumn
            label="Final repayment date"
            value={toDateFormat(loanDetails.finalRepaymentDate)}
          />
          <DetailsColumn
            label="Number of repayments remaining"
            value={`${loanDetails.numberOfRepayments}`}
          />
          <DetailsColumn
            label="Total of remaining monthly repayments"
            value={money(loanDetails.totalRepaymentAmount)}
          />
        </div>
        <div className="loan-items">
          <div className="loan-title">Loan Account</div>
          <DetailsColumn
            label="Current balance"
            value={`-${money(loanDetails.remainingBalance)}`}
          />
          <DetailsColumn
            label="Account number"
            value={loanDetails.accountNumber}
          />
          <DetailsColumn
            label="Sort code"
            value={formatSortCode(loanDetails.sortCode)}
          />
        </div>
      </DataCard>
    </>
  );
};
